import axios from 'axios';
import { apiWithAuth } from '../api';

export const getVendorProfile = async () => {
  const token = localStorage.getItem('token');
  console.log('getVendorProfile - Token:', token ? 'Present' : 'Missing');
  console.log('getVendorProfile - User ID:', localStorage.getItem('user_id'));
  
  try {
    const response = await apiWithAuth(token).get('/vendors/profile');
    console.log('getVendorProfile - Response:', response.data);
  return response.data;
  } catch (error) {
    console.error('getVendorProfile - Error:', error);
    throw error;
  }
};

export const updateVendorProfile = async (profileData) => {
  const token = localStorage.getItem('token');
  const isFormData = profileData instanceof FormData;
  const response = await apiWithAuth(token).put('/vendors/profile', profileData, {
    headers: isFormData ? {
      'Content-Type': 'multipart/form-data',
    } : {
      'Content-Type': 'application/json',
    },
  });
  return response.data;
};

export const getVendorEvents = async () => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).get('/vendor/events');
  return response.data;
};

export const getVendorById = async (id) => {
  const token = localStorage.getItem('token');
  console.log('getVendorById - ID:', id);
  console.log('getVendorById - Token:', token ? 'Present' : 'Missing');
  
  if (!token) {
    throw new Error('No authentication token found');
  }
  try {
    console.log('getVendorById - Making API call to:', `/vendors/${id}`);
    const response = await apiWithAuth(token).get(`/vendors/${id}`, {
      params: {
        include: ['category', 'user', 'ratings', 'applications', 'gallery_images']
      }
    });
    console.log('getVendorById - Raw response:', response);
    console.log('getVendorById - Response data:', response.data);
    console.log('Cover photo URL from API:', response.data.cover_photo_url); // Debug log
    console.log('Gallery images from API:', response.data.gallery); // Debug log for gallery images
    return response.data;
  } catch (error) {
    console.error('Error fetching vendor profile:', error);
    throw error;
  }
};

export const getVendorAttendedEvents = async (vendorId) => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).get(`/vendors/${vendorId}/events`);
  return response.data;
};

export const uploadGalleryImage = async (data) => {
  const token = localStorage.getItem('token');
  const formData = new FormData();
  formData.append('image', data.image);
  if (data.caption) {
    formData.append('caption', data.caption);
  }
  const response = await apiWithAuth(token).post('/vendors/gallery', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteGalleryImage = async (imageId) => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).delete(`/vendors/gallery/${imageId}`);
  return response.data;
};

export const updateVendorSocialMedia = async (socialMediaData) => {
  const token = localStorage.getItem('token');
  const response = await apiWithAuth(token).put('/vendors/social-media', socialMediaData);
  return response.data;
};

// Instagram Integration Services
export const getInstagramAuthorizeUrl = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get('/instagram/authorize');
    return response.data;
  } catch (error) {
    console.error('Error getting Instagram authorize URL:', error);
    throw error;
  }
};

export const getInstagramProfile = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get('/instagram/profile');
    return response.data;
  } catch (error) {
    console.error('Error getting Instagram profile:', error);
    throw error;
  }
};

export const getInstagramMedia = async (limit = 12) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get(`/instagram/media?limit=${limit}`);
    return response.data;
  } catch (error) {
    console.error('Error getting Instagram media:', error);
    throw error;
  }
};

export const disconnectInstagram = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).delete('/instagram/disconnect');
    return response.data;
  } catch (error) {
    console.error('Error disconnecting Instagram:', error);
    throw error;
  }
}; 